import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hire-a-helper': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M443.1 0c3.9 36.4 32.5 65.8 68.9 71.7v370.5c-35.4 4-64.9 33.4-67.9 69.8h-372.2c-5.9-36.4-34.5-63.9-71.9-68.8v-371.5c37.4-3.9 67.9-34.4 71.9-71.7h371.2zM406.1 404.9c7.8 0 5.8-10.8 0-10.8-10.3-3.4-13.5-3.6-21.7-13.8-7.8-12.9-7.9-44.4-7.9-127.8v-101.2c0-22.1 12.2-28.3 28.6-32.4 8.9-2.2 3.9-11.8-1-11.8-36.5 0-20.6 2-57.1 2-32.7 0-16.5-2-49.2-2-3.3 0-8.5 8.3-1 10.8 4.9 1.6 27.6 3.7 27.6 39.3 0 45.6 0.2 55.8-1 68.8 0 1.3-2.3 12.8-12.8 12.8h-109.2c-10.5 0-12.8-11.5-12.8-12.8-1.2-13-1-23.2-1-68.8 0-35.6 22.7-37.7 27.6-39.3 7.5-2.5 2.3-10.8-1-10.8-32.7 0-16.5 2-49.2 2-36.5 0-20.6-2-57.1-2-5 0-9.8 9.6-1 11.8 16.4 4.1 28.6 10.2 28.6 32.4v101.2c0 83.4-0.2 114.9-7.9 127.8-8.2 10.3-11.5 10.4-21.7 13.8-5.8 0-7.9 10.8 0 10.8 36.3 0 18.8-2 55.1-2 35.8 0 21 2 56.1 2 6 0 4.9-8.2 0-9.8-22.8-7.6-22.9-10.3-24.6-12.8-10.4-15.6-5.9-83-5.9-113 0-5.3 6.4-12.8 13.8-12.8h111.2c7.4 0 13.8 7.5 13.8 12.8 0 30 4.5 97.4-5.9 113-1.7 2.6-1.8 5.2-24.6 12.8-4.9 1.6-5.9 9.8 0 9.8 35.1 0 20.3-2 56.1-2 36.3 0 18.8 2 55.1 2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/hire-a-helper.js
// module id = 722
// module chunks = 0